import { Placement as PopperPlacement } from "@popperjs/core";

export declare type Placement = PopperPlacement;
